var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-inline" },
    [
      _c(
        "form-group",
        { attrs: { name: "runSheetTemplate", label: "Runsheet Template" } },
        [
          _c("vue-select", {
            attrs: {
              "data-testid": "runsheet-template",
              label: "name",
              options: _vm.options,
              value: _vm.selectedOption,
              clearable: false,
              searchable: _vm.$root.isDesktop,
            },
            on: { input: _vm.onUserSelect },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }